var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMagnifier(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.165,
    height: 25.001,
    viewBox: "0 0 24.165 25.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M17.155-511.8a10.352,10.352,0,0,0-4.7,1.993,13.088,13.088,0,0,0-1.875,1.875,11.591,11.591,0,0,0-1.538,2.847,10.143,10.143,0,0,0,4.283,11.926,10.16,10.16,0,0,0,10.685-.068l.371-.239.61.625c.337.342,1.719,1.778,3.077,3.189,2.8,2.915,2.676,2.808,3.36,2.769a1.085,1.085,0,0,0,.86-.366,1.258,1.258,0,0,0,.376-.943c0-.479-.117-.693-.737-1.333-2.051-2.12-5.528-5.748-5.528-5.773a3.086,3.086,0,0,1,.239-.332,10.05,10.05,0,0,0,1.768-3.643,10.078,10.078,0,0,0-1.773-8.664,13.224,13.224,0,0,0-1.885-1.885,10.218,10.218,0,0,0-4.757-1.983A14.45,14.45,0,0,0,17.155-511.8Zm2.452,2.662a7.368,7.368,0,0,1,4.122,2,7.379,7.379,0,0,1,1.6,8.522,7.64,7.64,0,0,1-3.057,3.292,7.419,7.419,0,0,1-6.261.5,7.472,7.472,0,0,1-4.8-7.521,6.982,6.982,0,0,1,.376-1.812,7.436,7.436,0,0,1,7.291-5.04C19.05-509.2,19.377-509.172,19.606-509.142Z",
    transform: "translate(-8.496 511.876)",
    fill: "#848484"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifier);
export default __webpack_public_path__ + "static/media/Magnifier.6eb4b6f209392dac99744cf20b657b58.svg";
export { ForwardRef as ReactComponent };